var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.14833 8.97135L7.71459 2.40511V6.51612C7.71459 6.75951 7.91191 6.95683 8.15529 6.95683C8.39868 6.95683 8.59599 6.75951 8.59599 6.51612V1.34109C8.59599 1.09772 8.39869 0.900375 8.15529 0.900391H2.98026C2.73687 0.900391 2.53956 1.09771 2.53956 1.34109C2.53956 1.58448 2.73687 1.7818 2.98026 1.7818H7.09134L0.525082 8.34805C0.352967 8.52017 0.352967 8.79922 0.525082 8.97133C0.611122 9.05733 0.724062 9.10041 0.836712 9.10041C0.949362 9.10041 1.06229 9.05735 1.14833 8.97135Z",
    fill: "#0B2E58",
    stroke: "#0B2E58",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkArrowIcon);
export default __webpack_public_path__ + "static/media/link-arrow-icon.9d042874f38e6bb17ff32ebe8676aacb.svg";
export { ForwardRef as ReactComponent };